import React, { useCallback } from 'react'
import cx from 'classnames'

import S from './styled'

const Tag = ({ title, valueId, onClick, selected, error, disabled }) => (
  <S.TagContainer onClick={disabled ? null : () => onClick(valueId)}>
    <S.Tag
      key={`tag_${valueId}`}
      className={cx({
        selected,
        error: !!error,
      })}
    >{title}</S.Tag>
  </S.TagContainer>
)

const GroupToggle = ({ title, name, value = [], values, onChange, error, oneLine, disabled }) => {
  const handleClick = useCallback(id => {
    onChange({
      target: {
        name, value: value.includes(id) ? value.filter(val => val !== id ) : [...value, id].sort(),
      },
    })
  }, [name, onChange, value])

  return (
    <S.TagsContainer className={cx({ twoRows: !oneLine, disabled })}>
      {title && <label>{title}</label>}
      <S.Tags className={cx({ oneLine: !!oneLine })}>
        {
          values.map(item => {
            const checked = value.includes(item)
            return (
              <Tag
                key={`tag_${item}`}
                title={item}
                valueId={item}
                onClick={handleClick}
                selected={checked}
                error={error}
                disabled={disabled}
              />
            )
          })
        }
      </S.Tags>
      {
        error && <S.ErrorLabel>{error}</S.ErrorLabel>
      }
    </S.TagsContainer>
  )
}

export default GroupToggle
